interface LocalStorageCommonProps {
    key: string;
}
interface SetLocalStorageProps extends LocalStorageCommonProps {
    value: unknown;
}
export const LOCAL_STORAGE = {
    get: ({ key }: LocalStorageCommonProps) => {
        return JSON.parse(localStorage.getItem(key) as string);
    },
    set: ({ key, value }: SetLocalStorageProps) => {
        localStorage.setItem(key, JSON.stringify(value));
    },
};
